import React, {useState} from 'react';
import uuid from 'react-uuid';
import moment from 'moment';
import {Card, Col, Form, Row, Table} from 'react-bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bs-stepper/dist/css/bs-stepper.min.css';

function PreviousFinding({data}) {

  const [steps, setSteps] = useState([...data].map((item, key) => {
    return {
      uuid: uuid(),
      isActive: false,
      title: moment(item.form.schedule.START_DATE).format('YYYY'),
      content: (
        <>
          <Row>
            <Col md="8">
              <Form.Group>
                <Form.Label>Root Cause</Form.Label>
                <p>{item.CAUSE_DESC}</p>
              </Form.Group>
            </Col>
            <Col md="4">
              <Form.Group>
                <Form.Label>Score</Form.Label>
                <p>{item.index.SCORE_INDEX}</p>
              </Form.Group>
              <Form.Group>
                <Form.Label>Auditor(s)</Form.Label>
                <p>
                  {item.form.schedule.auditorTeams.map(member => member.employee.EMP_NAME).join(', ')}
                </p>
              </Form.Group>
            </Col>
          </Row>
          <hr />
          {item.answerActions.map((action, key) => (
            <Card key={key}>
              <Card.Body>
                <Row>
                  <Col md="8">
                    <Form.Group>
                      <Form.Label>Action Plan</Form.Label>
                      <p>{action.PLAN_DESC}</p>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>{action.actionType.ACTION_TYPE_NAME}</Form.Label>
                      <p>{action.ACTION_DESC}</p>
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Due Date</Form.Label>
                      <p>{moment(action.DUE_DATE).format('DD - MMMM - YYYY')}</p>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Completed Date</Form.Label>
                      <p>{moment(action?.COMPLETED_AT).format('DD - MMMM - YYYY')}</p>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>PIC(s)</Form.Label>
                      <p>{action?.pics?.map(pic => pic.employee.EMP_NAME).join(', ')}</p>
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          ))}
        </>
      )
    }
  }));

  const handleClick = (uuid) => {

    setSteps([...steps].map(step => {
      return {...step, isActive: step.uuid === uuid}
    }));
  }

  return (
    <Form.Group>
      <Form.Label>Previous Finding(s)</Form.Label>
        {steps ? (
            <div
              id="progress-stepper"
              className="bs-stepper"
            >
              <div
                className="bs-stepper-header"
                style={{minWidth: '14rem'}}
              >
                {steps.map((step, key) => (
                  <>
                    <div
                      key={key}
                      className={`step ${step.isActive ? `active` : ``}`}
                      data-target={`#${step.uuid}-tab`}
                    >
                      <button
                        role="tab"
                        className={`step-trigger`}
                        aria-controls={step.uuid}
                        aria-selected={step.isActive}
                        onClick={() => handleClick(step.uuid)}
                      >
                        <span className="bs-stepper-circle">{key + 1}</span>
                        <span className="bs-stepper-label">{step.title}</span>
                      </button>
                    </div>
                    <div className="bs-stepper-line"></div>
                  </>
                ))}
              </div>
              <div className="bs-stepper-content">
                {steps.map((step, key) => (
                  <div
                    key={key}
                    style={{paddingLeft: 0, paddingRight: 0}}
                    role="tabpanel"
                    id={`${step.uuid}-tab`}
                    className={`content ${step.isActive ? `active` : ``}`}
                  >
                    <Card>
                      <Card.Header>
                        <Card.Title as="h4">Audit Schedule: {steps.find(step => step.isActive)?.title}</Card.Title>
                      </Card.Header>
                      <Card.Body>
                        {step.content}
                      </Card.Body>
                    </Card>
                  </div>
                ))}
              </div>
            </div>
          ) : <p>Data not available</p>
        }
    </Form.Group>
  );
}

export default React.memo(PreviousFinding);